export default "__VITE_ASSET__BiFXyGhg__"